<template>
    <div class="trombosprofylax">
        <admin-lock-border />
        <div class="header">
            <h1>Trombosprofylax</h1>
            <CustomButton type="button" variant="hollow" @click="openCreateTrombosprofylax">
                <img src="@/assets/plus_circle_blue.svg" />
                <span>Skapa ny trombosprofylax</span>
            </CustomButton>
        </div>

        <kliniken-table
            v-if="trombosprofylaxList.results"
            :items="trombosprofylaxList.results"
            paginationStyle="paging"
            :columns="columns"
            :count="count"
            :limit="limit"
            :currentPage="currentPage"
            @loadPage="loadPage"
            @changeLimit="changeLimit"
            @loadMore="loadMore"
            :showBottom="true"
            :showLimitDropdown="true"
            :has-dropdown="true"
            :dropdown-actions="dropdownActions"
            @edidTrombosprofylax="editTrombosprofylaxFromTable"
        />
    </div>
</template>

<script>
    import tabIcon from "@/assets/gear.svg";

    export default {
        name: "ListTrombosprofylax",
        tabName: "Trombosprofylax",
        icon: tabIcon,
    };
</script>

<script setup>
    import { onMounted, ref, onBeforeUnmount } from "vue";
    import emitter from "tiny-emitter/instance";
    import { openDialog } from "@/utils";
    import AdminLockBorder from "@/components/AdminLockBorder.vue";
    import { getConfig, klinikenApi } from "@/api";
    import KlinikenTable from "@/components/Table/KlinikenTable.vue";
    import CustomButton from "@/components/Button.vue";
    import Trombosprofylax from "./Trombosprofylax.vue";
    import store from "@/store";

    const trombosprofylaxList = ref([]);
    const count = ref(0);
    const columns = ref([
        {
            title: "Namn",
            name: "displayName",
        },
        {
            title: "Ordningsnummer",
            name: "ordning",
        },
        {
            title: "System",
            name: "system",
        },
        {
            title: "Systemnamn",
            name: "systemName",
        },
        {
            title: "OrginalText",
            name: "originalText",
        },
    ]);
    const dropdownActions = ref([
        {
            name: "edidTrombosprofylax",
            title: "Redigera trombosprofylax",
            show: () => true,
        },
    ]);

    const limit = ref(50);
    const offset = ref(0);
    const fetchBatch = ref(1);
    const params = ref({});
    const currentPage = ref(1);

    const loadPage = async (page) => {
        currentPage.value = page;
        offset.value = (page - 1) * limit.value;
        await fetchtrombosprofylaxList();
    };

    const loadMore = async () => {
        fetchBatch.value++;
        await this.fetchtrombosprofylaxList();
    };

    const changeLimit = async (dropdownLimit) => {
        fetchBatch.value = 1;
        limit.value = dropdownLimit;
        await fetchtrombosprofylaxList();
    };

    const fetchtrombosprofylaxList = async () => {
        params.value = { ...params.value, limit: limit.value, offset: offset.value };
        if (limit.value > 0) {
            params.value["limit"] = limit.value * fetchBatch.value;
        }
        try {
            const response = await klinikenApi.get(
                "/operation/kodverk/trombosprofylaxer/",
                getConfig({ params: { ...params.value } })
            );
            trombosprofylaxList.value = response.data;
            count.value = response.data.count;
        } catch (error) {
            openDialog("Kunde inte hämta Trombosprofylax.", "warning");
        }
    };

    const openCreateTrombosprofylax = () => {
        store.dispatch("tabs/openTab", {
            component: Trombosprofylax,
            parameters: { redigera: false },
        });
    };
    const editTrombosprofylaxFromTable = (trombosprofylax) => {
        store.dispatch("tabs/openTab", {
            component: Trombosprofylax,
            parameters: {
                redigera: true,

                ...trombosprofylax,
            },
        });
    };

    onMounted(() => {
        fetchtrombosprofylaxList();
        emitter.on("Trombosprofylax-table-uppdaterad", fetchtrombosprofylaxList);
    });

    onBeforeUnmount(() => {
        emitter.off("Trombosprofylax-table-uppdaterad", fetchtrombosprofylaxList);
    });
</script>
<style lang="scss">
    .trombosprofylax {
        .header {
            h1 {
                margin: 0;
            }

            display: flex;
            gap: 20px;
            align-items: center;
        }
    }
</style>
